import React, { Component } from 'react';
import './ChordDisplay.css'
import Keyboard from './Keyboard'

class ChordDisplay extends Component {
  render() {
    const chord = this.props.chord

    return (
      <div className="chord-display">
          <div className="chord-display-inner">
            <div className="chord-name"> 
              {chord.names[0]} 
            </div>
            <Keyboard 
              activeKeys={chord.keys}
            />
            <div className="chord-notes"> 
              <p> notes:
                {chord.notes.map((note) => 
                  <span key={note.id} className="note">{note.names[0]}</span>
                )} 
              </p>
            </div>
          </div>
      </div>
    )
  }
}

export default ChordDisplay


// WEBPACK FOOTER //
// ./src/ChordDisplay.js